import React, { InputHTMLAttributes } from 'react';

import { Container } from './styles';

interface buttonProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  value: string;
  imageMobile?: string;
  disabled?: boolean;
}

const ButtonOptions: React.FC<buttonProps> = ({
  name,
  value,
  imageMobile,
  disabled = false,
  onClick,
  ...rest
}) => {
  return (
    <Container
      imageMobile={!!imageMobile}
      isDisabled={disabled}
      onClick={disabled ? undefined : onClick}
      {...rest}
    >
      <span>{value}</span>
      <img src={imageMobile} alt="iconMobile" />
    </Container>
  );
};

export { ButtonOptions };
